export const Common_fa = {
    ok: 'باشه',
    cancel: 'انصراف',
    'Not Found!': 'موردی یافت نشد!',
};